import { NgForm } from '@angular/forms';
import {Component, OnInit, OnDestroy, ViewChild, ElementRef} from "@angular/core";
import {Observable} from "rxjs";
import * as Communication from "../communication/index";
import {Router, ActivatedRoute, NavigationEnd} from "@angular/router";
import { Subscription } from 'rxjs';
import {ToolbarService} from "../shared/common/ToolbarEventService";
import {NotificationService} from "../shared/common/NotificationService";
import {ToolbarEventPageEnum, ToolbarEvent} from "../shared/common/ToolbarEvent";
import {Authorization} from "../shared/authorization/authorization.component";
import {TranslateService} from '@ngx-translate/core';

declare var $:any;
declare var swal: any;

/**
 * This class represents the lazy loaded AccountComponent.
 */
@Component({
    selector: 'sd-account',
    templateUrl: 'account.component.html',
    styleUrls: ['account.component.css'],
    providers: [Communication.JobsService, Communication.DocumentsService, Communication.RecipientRequestService, Communication.PlansService, Communication.EmailsService, Communication.SubscriptionService, Communication.SftpService, Communication.TeamService, Communication.PreferencesService],
    standalone: false
})
export class AccountComponent implements OnInit, OnDestroy {

  routerEventSubscription: Subscription;
  timerSubscription:Subscription=null;
  subscriptions:Subscription[] = [];

  userMetadata:any = {};
  name:string="";
  title:string="";
  company:string="";
  country:string="";
  address:string="";
  language:string="";
  languages:any = [];
  countries:any = [];
  theAccountEmails:Array<Communication.UserEmail> = [];
  associatedEmail:string = "";
  associatedEmailIndex:number;
  userCallback:any = {};
  sftpUpdatedId:number;
  sftpDetails: Array<{
    id:number,
    serverName:string,
    serverAddress:string,
    port:number,
    username:string,
    password:string,
    certificateName:string,
    directory:string,
    departments:string
  }> = [];

  addSftpNameInput: string;
  addSftpServerInput: string;
  addSftpPortInput: number;
  addSftpUsernameInput: string;
  addSftpPasswordInput: string;
  addSftpDirectoryInput: string;
  addSftpDepartmentsInput: string;

  updateSftpNameInput: string;
  updateSftpServerInput: string;
  updateSftpPortInput: number;
  updateSftpUsernameInput: string;
  updateSftpPasswordInput: string;
  updateSftpDirectoryInput: string;
  updateSftpDepartmentsInput: string;

  @ViewChild("formAddSftp", {static:true}) formAddSftp: NgForm
  @ViewChild("formUpdateSftp", {static:true}) formUpdateSftp: NgForm

  addNewTeamMemberEmailInput: string;
  addNewTeamMemberDepartmentInput: string;

  @ViewChild("addTeamMemberForm", {static:true}) addTeamMemberForm: NgForm

  teamMemberDetails: Array<{
    id:number,
    owner:Communication.UserInfo,
    member:Communication.UserInfo,
    branch:string,
    status:string
  }> = [];

  teamMemberQuota:number = 0;
  isTeamMember:any = false;
  removedTeamMemberEmail:string;
  removedTeamMemberID:number;

  preferences: Communication.Preference = {
    emailYouSigned: true,
    emailSignatureAddedToYourJob: true,
    emailSignatureAddedTeamJob: true,
    emailSignatureRequestReceived: true,
    emailJobCompletedYouSent: true,
    emailJobCompletedTeamSent: true,
    emailSftpTransferYourJob: true,
    emailSftpTransferTeamJob: true,
    emailDailyDigest: true,
    dailyDigestHour: 16
  };

  digestHourOptions: number[] = Array.from({length: 13}, (_, i) => i + 7);
  preferencesLoaded: boolean = false;

  minApiKeyDate:Date;
  maxApiKeyDate:Date;
  today:Date = new Date();
  apiKey:{tokenName:string, expiresAt:Date} = {tokenName:"",expiresAt:this.today};
  apiKeyArray:Array<{
    id:number,
    tokenName:string,
    tokenId:string,
    tokenCreated:string,
    tokenExpire:string,
    tokenStatus:string
  }> = [];

  constructor(
              private emailsApi:Communication.EmailsService,
              private subscriptionApi: Communication.SubscriptionService,
              private router:Router,
              private toolbarService: ToolbarService,
              public authorization: Authorization,
              public notificationService: NotificationService,
              public translate: TranslateService,
              private sftpApi: Communication.SftpService,
              private teamApi: Communication.TeamService,
              private preferencesApi: Communication.PreferencesService) {

    this.getLanguages();
    this.getCountries();
  }


  ngOnInit() {

    this.today = new Date;
    this.maxApiKeyDate = new Date(this.today.getFullYear() + 1, this.today.getMonth(), this.today.getDate());
    this.minApiKeyDate = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() + 1)
    this.getApiKeys();

    if(!this.authorization.authenticated()) {
      this.router.navigate(['/']);
    }else{

      this.addSftpPortInput = 22;
      this.authorization.refreshSubscription();
      this.getSftpServers();
      this.toolbarService.action(new ToolbarEvent(ToolbarEventPageEnum.ACCOUNT, "", null, "", "", "", "", "", ""));
      this.InitFormData();
      this.getAccountEmails();
      this.getCallbackURL();
      this.getReturnURL();
      this.getTeamMembers();
      if (this.authorization?.userAccount?.subscription?.plan?.notificationControl === 'Y') {
        this.loadPreferences();
      }
      this.subscriptions.push(
        this.teamApi.teamIsmemberPost(
          this.authorization.getAccessToken()
        ).subscribe(
          (response:any) => {
            this.isTeamMember = response;
          },
          (error:any) => {
            console.log(error);
          }
        )
      )
    }
  }

  getAccountEmails(){
    this.subscriptions.push(this.emailsApi.usersEmailsGet(this.authorization.getAccessToken()).subscribe(
      (response:Array<Communication.UserEmail>) => {

        this.theAccountEmails = response;
        console.log("ALL account emails ", this.theAccountEmails)

      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err)
      }
    ));
  }

  public showAddEmailModal() {
    this.associatedEmail = "";
    $("#addNewEmail").modal('show'); //open add modal
  }

  public addEmail() {
    $("#addNewEmail").modal('hide'); //hide modal
    console.log(this.associatedEmail);
    this.addAccountEmail(this.associatedEmail);
  }

  addAccountEmail(email:string){
    this.subscriptions.push(this.emailsApi.usersEmailsPost(this.authorization.getAccessToken(), email).subscribe(
      (response:Array<Communication.UserEmail>) => {

        this.notificationService.newAccountEmailApprovalRequestSent(email);
        this.theAccountEmails = response;

        console.log("ALL account emails ", this.theAccountEmails)

      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err)
      }
    ));
  }

  showRemoveEmailAlert(formData:Communication.UserEmail){
    console.log("selected email adress to remove: ", formData);
    let self = this;
    this.notificationService.showAccountEmailDeleteAlert(formData.email, function(isConfirmed:boolean) {
      if(isConfirmed)
        self.deleteAccountEmail(formData);
    });
  }

  deleteAccountEmail(formData:Communication.UserEmail){
    this.subscriptions.push(this.emailsApi.usersEmailsEmailDelete(this.authorization.getAccessToken(), formData.email).subscribe(
      response => {
        console.log(formData.email, " adress deleted successfully");
        let index = this.theAccountEmails.indexOf(formData);
        this.theAccountEmails.splice(index,1);

        this.notificationService.accountEmailDeleted(formData.email);
      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err)
      }
    ));
  }

  saveCallbackURL() {
    this.subscriptions.push(this.subscriptionApi.subscriptionsUsercallbackPost(this.authorization.getAccessToken(), this.userCallback.callbackURL, "sign_post").subscribe(
      response => {
        console.log(response);
        this.notificationService.callbackAddressSaved();

      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err)
      }
    ));

  }

  getCallbackURL() {
    this.subscriptions.push(this.subscriptionApi.subscriptionsUsercallbackGet(this.authorization.getAccessToken(),"sign_post"  ).subscribe(
      response => {
        console.log(response);
        this.userCallback.callbackURL = response.url;

      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err)
      }
    ));

  }

  // Floating Labels
  getClasses(input:string):any{
    if(input && input.trim().length > 0) return "is-visible";
    else return "animate";
  }


  showSubscriptionInfo(){
    this.router.navigate(['/account/subscription']);
  }


  showUpgradePlans(){
    this.router.navigate(['/account/upgrade']);
  }


  public changePassword()
  {
    this.authorization.changePassword();
  }


  // <--- Update User ---->

  public showEditProfile() {
    this.InitFormData();

    $("#modalUpdateProfile").modal('show'); //open add modal
  }

  public InitFormData(){
    let userMetadata = this.authorization.userProfile.user_metadata;

    if(userMetadata) {
      this.name = userMetadata.name;
      this.title = userMetadata.title;
      this.company = userMetadata.company;
      this.country = userMetadata.country;
      this.address = userMetadata.address;
      this.language = userMetadata.language;
    }

    this.language= /(tr|en)/gi.test(this.language) ? this.language : "en"; // add new language as |de|fr|..

    this.userMetadata = {
      name:this.name,
      title:this.title,
      company:this.company,
      country:this.country,
      address:this.address,
      language:this.language
    };

    this.userCallback = {
      key: "",
      callbackURL: ""
    }
  }

  showCountryName(code:string){
    let country:string = "";
    this.countries.forEach((element:{isoCode:string,countryName:string}) => {
      if(element.isoCode == code){
        country = element.countryName;
        return
      }
    });
    return country == "" ? "" : this.translate.instant(country);
  }

  public getCountries(){
    this.countries = [
      {"isoCode":"","countryName":""},
      {"isoCode":"TR","countryName":"Turkey"},
      {"isoCode":"NL","countryName":"Netherlands"},
      {"isoCode":"US","countryName":"United States of America"},
      {"isoCode":"GB","countryName":"United Kingdom"},
      {"isoCode":"CA","countryName":"Canada"},
      {"isoCode":"BE","countryName":"Belgium"},
      {"isoCode":"BG","countryName":"Bulgaria"},
      {"isoCode":"HR","countryName":"Croatia"},
      {"isoCode":"CY","countryName":"Cyprus"},
      {"isoCode":"CZ","countryName":"Chech Republic"},
      {"isoCode":"DK","countryName":"Denmark"},
      {"isoCode":"EE","countryName":"Estonia"},
      {"isoCode":"FI","countryName":"Finland"},
      {"isoCode":"FR","countryName":"France"},
      {"isoCode":"GE","countryName":"Georgia"},
      {"isoCode":"DE","countryName":"Germany"},
      {"isoCode":"GR","countryName":"Greece"},
      {"isoCode":"HU","countryName":"Hungary"},
      {"isoCode":"IS","countryName":"Iceland"},
      {"isoCode":"IE","countryName":"Ireland"},
      {"isoCode":"IT","countryName":"Italy"},
      {"isoCode":"LV","countryName":"Latvia"},
      {"isoCode":"LI","countryName":"Liechtenstein"},
      {"isoCode":"LT","countryName":"Lithuania"},
      {"isoCode":"LU","countryName":"Luxembourg"},
      {"isoCode":"MT","countryName":"Malta"},
      {"isoCode":"NO","countryName":"Norway"},
      {"isoCode":"PL","countryName":"Poland"},
      {"isoCode":"PT","countryName":"Portugal"},
      {"isoCode":"RO","countryName":"Romania"},
      {"isoCode":"RS","countryName":"Serbia"},
      {"isoCode":"SI","countryName":"Slovakia"},
      {"isoCode":"SB","countryName":"Slovenia"},
      {"isoCode":"ES","countryName":"Spain"},
      {"isoCode":"SE","countryName":"Sweden"},
      {"isoCode":"CH","countryName":"Switzerland"},
      {"isoCode":"AU","countryName":"Australia"},
      {"isoCode":"NZ","countryName":"New Zealand"}
    ]
  }

  public getLanguages(){
    this.languages =
      [
        { value: 'tr', display: this.translate.instant('tr') },
        { value: 'en', display: this.translate.instant('en') }
      ];
  }


  public UpdateProfile(formData:any) {
    $("#modalUpdateProfile").modal('hide'); //hide modal

    this.authorization.updateProfile(formData, true);
    //console.log("language "+formData.language);
    let _thisInit= this;
    setTimeout(function ()
    {
      _thisInit.InitFormData(); //refresh after update
    }, 10);
  }

  generateApiKey(form: NgForm) {
    let expiryDate = new Date(this.apiKey.expiresAt);
    let dayDiff = Math.abs(Math.floor((Date.UTC(this.today.getFullYear(), this.today.getMonth(), this.today.getDate()) - Date.UTC(expiryDate.getFullYear(), expiryDate.getMonth(), expiryDate.getDate()) ) /(1000 * 60 * 60 * 24)));
    this.subscriptions.push(this.subscriptionApi.subscriptionsApikeyPost(this.authorization.getAccessToken(),this.apiKey.tokenName,dayDiff.toString()).subscribe(
      (response:any) => {
        console.log(response);
        this.userCallback.key = response.apikey;
        this.getApiKeys();
        form.resetForm();
      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err)
      }
    ));

  }

  revokeApiKey(id:number){
    let self = this;
    this.notificationService.revokeToken(function(isConfirmed:boolean) {
      if(isConfirmed){
        self.subscriptions.push(
          self.subscriptionApi.subscriptionsRevokeapikeyPost(self.authorization.getAccessToken(),id.toString()).subscribe(
            (response:any) => {
              console.log(response);
              self.getApiKeys();
              self.notificationService.afterRevokeToken();
            },
            (error:any) => {
              console.log(error);
              self.notificationService.displayError(error);
            }
          )
        )
      }
    });
  }

  deleteExpiredApiKey(id:number){
    this.subscriptions.push(
      this.subscriptionApi.subscriptionsApikeyDelete(this.authorization.getAccessToken(),id.toString()).subscribe(
        (response:any) => {
          this.notificationService.afterDeleteExpiredApiKey();
          this.getApiKeys();
        },
        (error:any) => {
          this.notificationService.displayError(error);
        }
      )
    )
  }

  getApiKeys(){
    this.subscriptions.push(
      this.subscriptionApi.subscriptionsApikeyGet(this.authorization.getAccessToken()).subscribe(
        (response:any) => {
          this.apiKeyArray = [];
          console.log(response)
          response.forEach((element:any) => {
            this.apiKeyArray.push({
              id:element.id,
              tokenCreated: element.createdAt,
              tokenExpire: element.expiresAt,
              tokenId: element.tokenId,
              tokenName: element.tokenName,
              tokenStatus: element.status
            });
          });
        },
        (error:any) => {
          console.log(error)
        }
      )
    )
  }

  showAddSftpServer(){
    $("#addNewSftpServer").modal('show');
  }

  showEditSftpServer(index:number){
    $("#updateSftpTitle").html(this.sftpDetails[index].serverName);
    this.updateSftpNameInput = this.sftpDetails[index].serverName;
    this.updateSftpServerInput = this.sftpDetails[index].serverAddress;
    this.updateSftpPortInput = this.sftpDetails[index].port;
    this.updateSftpUsernameInput = this.sftpDetails[index].username;
    this.updateSftpPasswordInput = this.sftpDetails[index].password;
    this.updateSftpDirectoryInput = this.sftpDetails[index].directory;
    this.updateSftpDepartmentsInput = this.sftpDetails[index].departments;
    this.sftpUpdatedId = this.sftpDetails[index].id;
    $("#editSftpServer").modal('show');
  }

  getSftpServers(){
    this.sftpDetails = [];
    this.subscriptions.push(
      this.sftpApi.sftpGet(
        this.authorization.getAccessToken()
      ).subscribe(
        (response: any) => {
          for(let i=0;i<response.length;i++){
            if ( response[i].id != null && response[i].id != undefined ) {
              this.sftpDetails.push({
                id: response[i].id,
                serverName: response[i].serverName,
                serverAddress: response[i].serverAddress,
                port: +response[i].serverPort,
                username: response[i].serverUsername,
                password: response[i].serverPassword,
                certificateName: "Sertifika ismi",
                departments: response[i].departments,
                directory: response[i].serverDirectory
              });
            }
          }
        },
        err => {
          console.log(err);
        }
      )
    )
  }

  addSftpServer(form: NgForm){
    const value = form.value;
    if(value.sftpDirectory == null || value.sftpDirectory == "" || value.sftpDirectory == undefined){
      value.sftpDirectory = "NULL_DIRECTORY";
    }

    this.subscriptions.push(
      this.sftpApi.sftpPut(
        this.authorization.getAccessToken(),
        value.sftpName,
        value.sftpServer,
        value.sftpPort.toString(),
        value.sftpUsername,
        value.sftpPassword,
        value.sftpDirectory,
        value.sftpDepartments
      ).subscribe(
        response => {
          console.log(response);
          this.getSftpServers();
          $("#addNewSftpServer").modal('hide');
          this.formAddSftp.reset();
          this.addSftpPortInput = 22;
          this.notificationService.sftpServerAdded();
        },
        err => {
          console.log(err);
          this.notificationService.sftpServerAddedError()
        }
      )
    );
  }

  editSftpServer(form:NgForm){
    const value = form.value;
    if(value.updateSftpDirectory == null || value.updateSftpDirectory == "" || value.updateSftpDirectory == undefined){
      value.updateSftpDirectory = "NULL_DIRECTORY";
    }

    this.subscriptions.push(
      this.sftpApi.sftpPost(
        this.authorization.getAccessToken(),
        this.sftpUpdatedId.toString(),
        value.updateSftpName,
        value.updateSftpServer,
        value.updateSftpPort,
        value.updateSftpUsername,
        value.updateSftpPassword,
        value.updateSftpDirectory,
        value.updateSftpDepartments
      ).subscribe(
        response => {
          console.log(response);
          this.getSftpServers();
          $("#editSftpServer").modal('hide');
          this.notificationService.sftpServerUpdated();
        },
        err => {
          console.log(err);
          this.notificationService.sftpServerUpdatedError();
        }
      )
    );
  }

  deleteSftpServer(sftpId:number){
    this.subscriptions.push(
      this.sftpApi.sftpDelete(
        this.authorization.getAccessToken(),
        sftpId.toString()
      ).subscribe(
        response => {
          console.log(response);
          this.getSftpServers();
          this.notificationService.sftpServerDeleted();
        },
        err => {
          console.log(err);
          this.notificationService.sftpServerDeletedError();
        }
      )
    )
  }

  showRemoveSftpAlert(sftpName:string, sftpId:number){
    console.log("selected sftp server to remove: ", sftpName);
    let self = this;
    this.notificationService.showAccountSftpDeleteAlert(sftpName, function(isConfirmed:boolean) {
      if(isConfirmed){
        self.deleteSftpServer(sftpId);
      }
    });
  }

  onAddServerCancelButtonClicked(){
    this.formAddSftp.reset();
    this.addSftpPortInput = 22;
  }

  getTeamMembers(){
    this.teamMemberDetails = [];
    this.subscriptions.push(
      this.teamApi.teamGet(
        this.authorization.getAccessToken()
      ).subscribe(
        (response:any) => {
          var i;
          for(i=0;i<response.length;i++){
            this.teamMemberDetails.push(response[i]);
          }
          let quota = this.authorization.userAccount.subscription.plan.teammembers + this.authorization.userAccount.subscription.extraTeammembers;
          this.teamMemberQuota = quota;
          if(this.teamMemberDetails.length < quota){
            for(let k=i;k<quota;k++){
              this.teamMemberDetails.push({
                id:null,
                owner:null,
                member:null,
                branch:null,
                status:null
              })
            }
          }
        },
        (error:any) => {
          console.log(error);
        }
      )
    )
  }

  addTeamMember(){
    this.subscriptions.push(
      this.teamApi.teamPut(
        this.authorization.getAccessToken(),
        this.addNewTeamMemberEmailInput.trim(),
        this.addNewTeamMemberDepartmentInput.trim()
      ).subscribe(
        response => {
          console.log(response);
          this.getTeamMembers();
          $("#addNewTeamMember").modal('hide');
          this.notificationService.showTeamMemberRequestSent();
          this.addTeamMemberForm.reset();
        },
        error => {
          console.log(error);
          let json = error.error;
          if(json.code == 256){
            this.notificationService.showUserAlreadyInTeam();
          } else if(json.code == 255){
            this.notificationService.showNoUserFoundAlert();
          } else if(json.code == 261){
            this.notificationService.teamMemberQuotaFull();
          } else {
            console.log(error);
            this.notificationService.displayError(error);
          }
        }
      )
    )
  }

  showRemoveTeamMemberAlert(memberEmail:string,memberId:number){
    $("#removeNewTeamMember").modal("show");
    this.removedTeamMemberEmail = memberEmail;
    this.removedTeamMemberID = memberId;
  }

  showCancelTeamMemberRequestAlert(memberEmail:string, memberId:number){
    let self = this;
    this.notificationService.showCancelTeamMemberRequestAlert(memberEmail, function(isConfirmed:boolean){
      if(isConfirmed){
        self.cancelTeamMemberRequest(memberId);
      }
    })
  }

  cancelTeamMemberRequest(memberId:number){
    this.subscriptions.push(
      this.teamApi.teamCancelPost(
        this.authorization.getAccessToken(),
        memberId.toString()
      ).subscribe(
        response => {
          console.log(response);
          this.notificationService.showTeamMemberRequestCancelled();
          this.getTeamMembers();
        },
        error => {
          console.log(error);
        }
      )
    )
  }

  deleteTeamMember(){
    console.log(this.removedTeamMemberID);
    let newMemberID = $("#assignMemberDropdown").val();
    console.log(newMemberID);
    this.subscriptions.push(
      this.teamApi.teamDelete(
        this.authorization.getAccessToken(),
        this.removedTeamMemberID.toString(),
        newMemberID.toString()
      ).subscribe(
        response => {
          console.log(response);
          $("#removeNewTeamMember").modal("hide");
          this.notificationService.showTeamMemberRemoved();
          this.getTeamMembers();
        },
        error => {
          console.log(error);
        }
      )
    )
  }

  transferFilesAlert(){
    let self = this;
    this.notificationService.showTransferFilesAlert(function(isConfirmed:boolean){
      if(isConfirmed){
        self.transferMemberFilesToOwner();
      }
    })
  }

  transferMemberFilesToOwner(){
    this.subscriptions.push(
      this.teamApi.teamTransferfilesPost(
        this.authorization.getAccessToken()
      ).subscribe(
        (response:any) => {
          console.log(response);
          this.notificationService.transferFileCompleted();
        },
        (error:any) => {
          console.log(error);
          this.notificationService.displayError(error);
        }
      )
    )
  }

  showAddNewTeamMember(){
    $("#addNewTeamMember").modal('show');
  }

  loadPreferences() {
    this.subscriptions.push(
      this.preferencesApi.usersPreferencesGet(
        this.authorization.getAccessToken()
      ).subscribe(
        (response: Communication.Preference) => {
          this.preferences = response;
          this.preferencesLoaded = true;
        },
        (error: any) => {
          if (error.status === 403) {
            this.preferencesLoaded = false;
          } else {
            console.log(error);
          }
        }
      )
    );
  }

  savePreferences() {
    const snapshot = { ...this.preferences };
    this.subscriptions.push(
      this.preferencesApi.usersPreferencesPut(
        this.authorization.getAccessToken(),
        this.preferences.emailYouSigned,
        this.preferences.emailSignatureAddedToYourJob,
        this.preferences.emailSignatureAddedTeamJob,
        this.preferences.emailSignatureRequestReceived,
        this.preferences.emailJobCompletedYouSent,
        this.preferences.emailJobCompletedTeamSent,
        this.preferences.emailSftpTransferYourJob,
        this.preferences.emailSftpTransferTeamJob,
        this.preferences.emailDailyDigest,
        this.preferences.dailyDigestHour
      ).subscribe(
        (response: Communication.Preference) => {
          this.notificationService.notificationPreferencesSaved();
        },
        (error: any) => {
          console.log(error);
          this.preferences = snapshot;
          this.notificationService.notificationPreferencesSaveError();
        }
      )
    );
  }

  onToggleChange() {
    this.savePreferences();
  }

  ngOnDestroy() {

    $('.modal-backdrop').remove(); //browser ileri-geri tuşuna basıncaki kırıklığı önlemek

    this.subscriptions.forEach(
      (s:Subscription) => s.unsubscribe()
    );
    if (this.timerSubscription != null) {
      this.timerSubscription.unsubscribe();

    }
  }

  saveReturnURL() {
      this.subscriptions.push(this.subscriptionApi.subscriptionsUsercallbackPost(this.authorization.getAccessToken(), this.userCallback.returnURL, "sign_return").subscribe(
        response => {
          console.log(response);
          this.notificationService.callbackAddressSaved();

        }, //Bind to view
        err => {
          // Log errors if any
          console.log(err);
          this.notificationService.displayError(err)
        }
      ));

  }

  private getReturnURL() {
    this.subscriptions.push(this.subscriptionApi.subscriptionsUsercallbackGet(this.authorization.getAccessToken(), "sign_return").subscribe(
      response => {
        console.log(response);
        this.userCallback.returnURL = response.url;

      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err)
      }
    ));
  }
}
